__turbopack_context__.v({
  "actions": "AgreementDetails-module-scss-module__2wxTGq__actions",
  "textWrapper": "AgreementDetails-module-scss-module__2wxTGq__textWrapper",
  "wrapper": "AgreementDetails-module-scss-module__2wxTGq__wrapper",
});
